
import { useState } from "react";

export function ExperienceItem({ exp }: { exp: any; index?: number }) {
    const [logoError, setLogoError] = useState(false);
    const companyName = exp?.company || exp?.company_name || "";
    const title = exp?.title || exp?.position || "";
    const duration = exp?.duration || exp?.time_period || "";
    const description = exp?.description || exp?.summary || "";
    const companyLogoUrl = exp?.company_logo_url || exp?.logo_url || "";
  
    return (
      <div className="flex items-start gap-3 sm:gap-4">
        {/* Company Logo/Icon */}
        <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center overflow-hidden"
          style={{ backgroundColor: (companyLogoUrl && !logoError) ? 'transparent' : '#DC2626' }}
        >
          {(companyLogoUrl && !logoError) ? (
            <img
              src={companyLogoUrl}
              alt={companyName}
              width={40}
              height={40}
              className="w-full h-full object-cover"
              onError={() => setLogoError(true)}
            />
          ) : (
            <span className="text-sm text-white font-bold">
              {companyName.charAt(0).toUpperCase()}
            </span>
          )}
        </div>
        
        {/* Experience Details */}
        <div className="flex-1">
          <p 
            className="font-bold text-base sm:text-lg mb-1"
            style={{ 
              fontFamily: 'Inter, sans-serif',
              color: '#1D1D1D'
            }}
          >
            {title}
          </p>
          <p 
            className="text-sm sm:text-base text-gray-600 mb-1 flex items-center gap-1"
            style={{ 
              fontFamily: 'Inter, sans-serif'
            }}
          >
            <span>{companyName}</span>
            {exp.job_type && (
              <>
                <span className="flex items-center">·</span>
                <span>{exp.job_type}</span>
              </>
            )}
            {duration && (
              <>
                <span className="flex items-center">·</span>
                <span>{duration}</span>
              </>
            )}
          </p>
          {description && (
            <p 
              className="text-sm text-gray-600"
              style={{ 
                fontFamily: 'Inter, sans-serif',
                lineHeight: '1.5'
              }}
            >
              {description}
            </p>
          )}
        </div>
      </div>
    );
  }